import { ConnectionNames } from "../contracts";
import { createSportsbookConnection } from "../c_sportsbook";
export const ConnectionsFactory = {
    [ConnectionNames.sports]: createSportsbookConnection,
};
//# sourceMappingURL=ConnectionsFactory.js.map